import axios from "axios";

const useImageUpload = () => {
  const uploadImage = async (file) => {
    const formData = new FormData();
    // Backend expects 'media_file'
    formData.append("media_file", file);
    formData.append("upload_from", "local");
    formData.append("user_id", "679086ffffb3896f0da4b84a");

    try {
      const res = await axios.post(
        `https://us2.sourcesoftsolutions.com:8031/upload-media`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      // Backend should return { "file_path": "/uploads/media/...png" }
      const imagePath = res.data?.file_path || res.data?.url;
      if (!imagePath) {
        console.error("No image path returned from backend:", res.data);
        return null;
      }

      // Ensure full URL
      const fullImageUrl = imagePath.startsWith("http")
        ? imagePath
        : `https://us2.sourcesoftsolutions.com:8031${
            imagePath.startsWith("/") ? "" : "/"
          }${imagePath}`;

      console.log("Image uploaded successfully:", fullImageUrl);
      return fullImageUrl;
    } catch (err) {
      console.error("Image upload failed:", err);
      return null;
    }
  };

  return { uploadImage };
};

export default useImageUpload;
